export default "__VITE_ASSET__BHKgSI4A__"